import React from 'react';
import { useForm } from '../../context/FormContext';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { FileText } from 'lucide-react';

export const NotesStep = () => {
  const { formData, updateFormData } = useForm();

  return (
    <div className="space-y-6" data-testid="notes-step">
      <div className="text-center">
        <div className="w-16 h-16 brand-bg-medium rounded-full hidden md:flex items-center justify-center mx-auto mb-4">
          <FileText className="w-8 h-8 brand-text" />
        </div>
        <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Additional Notes
        </h2>
        <p className="text-slate-600 hidden md:block">
          Add any additional supporting information or notes for this application to be reviewed (optional)
        </p>
      </div>

      <div className="space-y-4">
        <div>
          <Label htmlFor="additional_notes" className="text-slate-700 font-medium">
            Notes
          </Label>
          <Textarea
            id="additional_notes"
            placeholder="Enter any additional notes or comments about this application..."
            value={formData.additional_notes || ''}
            onChange={(e) => updateFormData({ additional_notes: e.target.value })}
            className="mt-2 min-h-[150px] resize-y"
            data-testid="additional-notes-input"
          />
          <p className="text-xs text-slate-500 mt-2">
            These notes will be added to the application as a warning note visible to the underwriters.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotesStep;
